// If the photo detail is opened from claims tab
export const photoDetailOrigin = { claim: "claim" } as const

export type PhotoDetailOrigin = (typeof photoDetailOrigin)[keyof typeof photoDetailOrigin]

export const urls = {
  auth: {
    resetPassword: "/auth/reset-password",
    resetPasswordToken: (token: string) => `/auth/reset-password/${token}`,
    verifyEmail: "/auth/verify-email",
    verifyEmailToken: (token: string) => `/api/verify-email/${token}`,
    signin: "/auth/signin",
    signup: "/auth/signup",
    signupCheckYourEmail: "/auth/signup/check-your-email",
    signupSetPassword: (token: string) => `/auth/signup/${token}`,
    invalidToken: "/auth/invalid-token",
  },
  app: {
    home: "/",

    sessions: "/sessions",
    sessionDetail: (sessionId: string) => `/sessions/${sessionId}`,
    sessionPhotoDetail: (sessionId: string, sessionPhotoId: string, origin?: PhotoDetailOrigin) =>
      `/sessions/${sessionId}/${sessionPhotoId}${origin ? `?from=${origin}` : ""}`,

    claims: "/claims",
    claimDetail: (claimId: string) => `/claims/${claimId}`,
    claimMarkerDetail: (claimId: string, markerId: string) => `/claims/${claimId}/markers/${markerId}`,

    reports: "/reports",
    reportDetail: (reportId: string) => `/reports/${reportId}`,

    accountSettings: "/account/settings",
  },
} as const
